<template>
  <div class="pageContent">
    <div class="dataTitle">
      <van-icon
        class="hospiyalsArrowLeft"
        style="top: 16px;"
        name="arrow-left"
        @click="onBack"
        v-if="forwardingReport"
      />
      <div class="title">
        <div class="content" @click="toReport" v-if="examReport">检查报告</div>
        <div class="line" v-if="examReport">|</div>
        <div class="content action">数字影像</div>
        <div class="line" v-if="reportInfoData[0].institution_id !== '06300007'">|</div>
        <div class="content" v-if="reportInfoData[0].institution_id !== '06300007'" @click="toAttachment">附件</div>
        <div class="line" v-if="forwardingReport">|</div>
        <div class="content" @click="toForwarding" v-if="forwardingReport">转发报告</div>
      </div>
    </div>
    <div class="portraitContent">
      <iframe :src="src" frameborder="0"></iframe>
    </div>
    <div class="inspectionMontmorillonite" v-if="Montmorillonite">
      <div class="inspectionInputBox">
        <div class="inspectionInputBoxPrompt">提示</div>
        <div class="inspectionInputBoxContent">
          <div class="inspectionInputBoxContentTitle">请输入4位密码查看{{xxx}}的检查报告</div>
          <div class="inspectionInputBoxContentPassword">
            输入密码：
            <input v-model="code" type="text" />
          </div>
        </div>
        <div class="inspectionInputBoxButton">
          <span @click="cencelMontmorillonite">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getReportByCode } from "@/api/report";
import Storage from "@/tools/storage";
import getQueryString from "@/tools/getUrlParams";
export default {
  name: "portrait",
  data() {
    return {
      xxx: Storage.get("makeReportLinkName"),
      src: "",
      code: "",
      examReport: true,
      forwardingReport: true,
      examId: true,
      Montmorillonite: false,
      isAnonymous: 0,
      isEncrypt: 0,
      reportInfoData: []
    };
  },
  methods: {
    toReport() {
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        if(url.indexOf("service=1") != -1) {
          window.location.href = hostname[0]+'/#/reportInfo/reportStemp?'+ Storage.get("reportParams")
        }else {
          window.location.href = hostname[0]+'/#/reportInfo/report?'+ Storage.get("reportParams")
        }
      }else{
        this.$router.push({ path: "/reportInfo/report"})
      }
    },
    onBack() {
      // this.$router.push({ path: "/filmQuery" });
      this.$router.go(-1);
    },
    toForwarding() {
      // this.$router.push({ path: "/reportInfo/forwarding" });
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/forwarding?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/forwarding"})
      }
    },
    toAttachment() {
      // this.$router.push({ path: "/reportInfo/attachment" });
      let url = window.location.href;
      let hostname = url.split('/#/')
      if(Storage.get("reportParams")){
        window.location.href = hostname[0]+'/#/reportInfo/attachment?'+ Storage.get("reportParams")
      }else{
        this.$router.push({ path: "/reportInfo/attachment"})
      }
    },
    async cencelMontmorillonite() {
      let params = { id: Storage.get("makeReportLinkId"), code: this.code };
      let res = await getReportByCode(params);
      if (res == null) {
        Storage.set("isShows", 1);
      } else {
        Storage.set("reportInfo", res);
        if (res.study_id) {
          Storage.set("studyId", res.study_id);
          this.showImage(res.study_id)
        } else {
          Storage.set("studyId", res[0].study_id);
          this.showImage(res[0].study_id)
        }
        Storage.set("isShows", 2);
        this.Montmorillonite = false;

      }
    },
    showImage(data){
      let reportInfo = JSON.parse(Storage.get("reportInfo"));
      let baseUrl = "https://mpacsview.pacsonline.cn/#/mobile?studyurl=https%3A%2F%2Fquery.pacsonline.cn%2Fquery%3Faddress%3D&study_id="
      if(this.isAnonymous == 1){
        this.src = baseUrl + data + '&node_type=' + reportInfo[0].node_type + '&anonymous=1';
      }else{
        this.src = baseUrl + data + '&node_type=' + reportInfo[0].node_type;
      }
      // 'https://static.pacsview.pacsonline.cn/#/mobile?studyurl=https%3A%2F%2Fparsecallback.pacsonline.cn%2Fstudy%2Fquery%3Faddress%3D&study_id=' +
      // "https://mpacsview.pacsonline.cn/#/mobile?studyurl=https%3A%2F%2Fparsecallback.pacsonline.cn%2Fstudy%2Fquery%3Faddress%3D&study_id=" +
    }
  },
  created() {
    let url = window.location.href;
    this.isEncrypt = this.$route.query.isEncrypt
    this.isAnonymous = this.$route.query.isAnonymous
    this.reportInfoData = JSON.parse(Storage.get('reportInfo'))

    // this.handleChange()
    if (url.indexOf("report_id=") != -1) {
      let openid = getQueryString("openid");
      let examId = getQueryString("exam_id");
      let reportId = getQueryString("report_id");
      Storage.set("openid", openid);
      Storage.set("reportId", reportId);
      Storage.set("examId", examId);
      // this.wechatLogin()
      // this.getOneReport();
      return;
    }
    if (url.indexOf("short=1") != -1 || url.indexOf("smslink=1") != -1) {
      if (url.indexOf("short=1") != -1 && url.indexOf("id=") != -1) {
        let str = url.match(/id=(\S*)&short/)[1];
        Storage.set("makeReportLinkId", str);
        let string = url.indexOf("name=");
        let names = url.substring(string);
        let num = names.indexOf("=");
        let name = names.substring(num + 1);
        this.xxx = decodeURI(name) + "的";
        Storage.set("makeReportLinkName", decodeURI(name));
      } else if (url.indexOf("smslink=1") != -1 && url.indexOf("id=") != -1) {
        if (url.indexOf("?") != -1) {
          Storage.set("reportParams", url.split('?')[1]);
        }
        Storage.set("makeReportLinkId", this.$route.query.id);
        this.xxx = "";
      }
      if (Storage.get("isShows") == 1 || Storage.get("isShows") == null) {
        this.Montmorillonite = true;
      } else {
        this.Montmorillonite = false;
      }
      Storage.set("reportPermissions", 1);
    } else {
      this.Montmorillonite = false;
      let examId = JSON.parse(Storage.get("reportInfo"));
      let exam_id = examId ? examId[0].exam_id : Storage.get("examId");
      if (exam_id) {
        this.handleChange(exam_id);
      }
    }
    if (Storage.get("reportPermissions") && getQueryString("id") != 'cnb518tkh0ou8lx9') {
      this.forwardingReport = false;
    }
  },
  mounted() {
    let data = Storage.get("studyId");
    data && this.showImage(data)
  }
};
</script>
<style lang="scss" scoped>
.portraitContent {
  padding-top: 55px;
  iframe {
    width: 100%;
    height: calc(100vh - 55px);
  }
}
</style>

